import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import CountUp from 'react-countup';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    totalStartups: 0,
    totalMentors: 0,
    totalInvestors: 0,
    totalUsers: 0,
    recentUsers: [],
    pendingRequests: 0,
    walletBalance: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch dashboard data from the backend using fetch API
    fetch('https://back.startupconnectz.com/api/admin/dashboard')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch data: ' + response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        setDashboardData(data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Error: ' + err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="dashboard-wrapper">
      {/* Statistics Section */}
      <div className="statistics-container">
        <div className="statistics-grid">
          <div className="statistic-card">
            <span className="stat-title">Startups</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.totalStartups} duration={2.5} />
            </span>
          </div>
          <div className="statistic-card">
            <span className="stat-title">Investors</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.totalInvestors} duration={2.5} />
            </span>
          </div>
          <div className="statistic-card">
            <span className="stat-title">Mentors</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.totalMentors} duration={2.5} />
            </span>
          </div>
        </div>

        {/* Second Row of Statistics */}
        <div className="statistics-grid">
          <div className="statistic-card">
            <span className="stat-title">Total Users</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.totalUsers} duration={2.5} />
            </span>
          </div>
          <div className="statistic-card">
            <span className="stat-title">Pending Requests</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.pendingRequests} duration={2.5} />
            </span>
          </div>
          <div className="statistic-card">
            <span className="stat-title">Wallet Balance</span>
            <span className="stat-value">
              <CountUp start={0} end={dashboardData.walletBalance} duration={2.5} separator="," prefix="₹ " />
            </span>
          </div>
        </div>
      </div>

      {/* Recent Users Section */}
      <div className="recent-users-wrapper">
        <h3>Recent Users:</h3>
        <div className="recent-users-list">
          {dashboardData.recentUsers.map((user, index) => (
            <div key={index} className="user-item">
              <div className="user-type">{user.type}</div> {/* Display user type (Startup, Investor, Mentor) */}
              <div className="user-name">
                <strong>{user.name}</strong> {/* Display user name */}
              </div>
              <div className="user-email">{user.email}</div>
              <div className="user-createdAt">
                <span>{new Date(user.createdAt).toLocaleString()}</span> {/* Display the date of registration */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
